module.exports = __webpack_public_path__ + "img/check.3459d296.svg";